var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.234,
    height: 33.234,
    viewBox: "0 0 33.234 33.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "volume-1",
    transform: "translate(7.967 5.617)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M15.053,5,7.8,10.8H2v8.7H7.8l7.251,5.8Z",
    transform: "translate(-2 -5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M15.54,8.46a7.251,7.251,0,0,1,0,10.254",
    transform: "translate(4.097 -3.442)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_516",
    "data-name": "Rectangle 516",
    transform: "translate(28.284 2.828) rotate(45)",
    fill: "#a7a398",
    stroke: "#f8f2e1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 36,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 5,
    height: 38,
    rx: 2.5,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOff);
export default __webpack_public_path__ + "static/media/audio_off.5164529e0ab50969fb3f1250d385eaca.svg";
export { ForwardRef as ReactComponent };